package fr.manyverse.app.domain.validation

import fr.manyverse.app.domain.error.ValidationError
import fr.manyverse.app.domain.model.UniverseConfig

object UniverseValidator {

    const val MAX_NAME_LENGTH = 30

    fun validateName(name: String): Result<Unit> {
        val trimmed = name.trim()
        return when {
            trimmed.isEmpty() -> Result.failure(ValidationError("Universe name cannot be empty"))
            trimmed.length > MAX_NAME_LENGTH -> Result.failure(
                ValidationError("Universe name must be $MAX_NAME_LENGTH characters or less")
            )
            else -> Result.success(Unit)
        }
    }

    fun validateConfig(config: UniverseConfig): Result<Unit> {
        if (!config.features.dice) return Result.success(Unit)
        if (config.dice.available.isEmpty()) {
            return Result.failure(ValidationError("At least one die must be available"))
        }
        if (config.dice.available.none { it.type == config.dice.defaultDie }) {
            return Result.failure(ValidationError("Default die must be in the available dice list"))
        }
        if (config.dice.defaultCount < 1) {
            return Result.failure(ValidationError("Default dice count must be at least 1"))
        }
        config.dice.available.forEach { die ->
            val min = die.criticalMin
            val max = die.criticalMax
            if (min != null && (min < 1 || min > die.type.sides)) {
                return Result.failure(ValidationError("Invalid critical min for ${die.type}"))
            }
            if (max != null && (max < 1 || max > die.type.sides)) {
                return Result.failure(ValidationError("Invalid critical max for ${die.type}"))
            }
            if (min != null && max != null && min >= max) {
                return Result.failure(ValidationError("Critical success and critical failure must be different for ${die.type}"))
            }
        }
        return Result.success(Unit)
    }

    fun validateForCreation(name: String, config: UniverseConfig): Result<Unit> {
        validateName(name).onFailure { return Result.failure(it) }
        validateConfig(config).onFailure { return Result.failure(it) }
        return Result.success(Unit)
    }
}
